<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-23 10:16:47
 * @LastEditTime: 2019-10-22 02:04:32
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="withdraw">
    <div class="cash">
      <div class="first">
        <div class="left">提现金额</div>
        <div class="right">可提现余额￥{{accountData.availableWithdrawAmountView}}</div>
      </div>
      <div class="money">
        <div>￥</div>
        <input class="weui-input"
               type="number"
               maxlength="6"
               v-model="cashMoney"
               :placeholder="accountData.availableWithdrawAmountView">
      </div>
    </div>
    <div class="tip">
      <div class="inner"></div>
      <div class="tip_msg">扣除个人所得税{{realLostMoney}}元，实际到账{{realGetMoney}}元</div>
      <img @click="clickQuestionBtn"
           :src="iceIcon"
           alt="">
    </div>
    <div class="msg">
      <label>提示：</label>
      <p>提现款项将发放至您的微信零钱，<span>单日可提现1次，上限500元</span><br>活动中获得的战力值将转换为提现余额(100战力值=1元)</p>
    </div>
    <div v-if="isShowBtn">
      <div class="btn"
           v-if="canClickBtn"
           @click="navigateToWithdraw">提现</div>
      <div v-else
           class="btn btn_disable">提现</div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, floatMul, floatSub, floatDiv, appCertificationClick } from '@/utils/index.js'
export default {
  name: 'withdraw',
  data () {
    return {
      cashMoney: 0,
      canClickBtn: true,
      accountData: {},
      realGetMoney: '0.00',
      realLostMoney: '0.00',
      iceIcon: this.$store.state.ossLink + 'share/share_icon_explain.png',
      deviceType: 0,
      isShowBtn: false
    }
  },
  watch: {
    cashMoney (val) {
      let self = this
      if (val) { self.changeCashMoney(val) }
    }
  },
  methods: {
    startToWithdraw () {
      var self = this
      if (!self.cashMoney || self.cashMoney === '') {
        self.$weui.toast('请输入要提现的金额', {
          duration: 2000,
          className: 'toast_text'
        })
        return
      }
      if (!/^\d+(\.\d+)?$/.test(self.cashMoney)) {
        self.$weui.toast('请输入正确的提现金额', {
          duration: 2000,
          className: 'toast_text'
        })
        return
      }
      if (self.accountData.availableWithdrawAmount < parseFloat(self.cashMoney)) {
        self.$weui.toast('提现金额不可大于可提现余额', {
          duration: 2000,
          className: 'toast_text'
        })
        return
      }
      if (parseFloat(self.cashMoney) > 500) {
        self.$weui.toast('提现金额不可高于500', {
          duration: 2000,
          className: 'toast_text'
        })
        return
      }
      self.canClickBtn = false
      console.log(self.cashMoney)
      self.nowStartWithdraw()
    },
    changeCashMoney (val) {
      let self = this
      if (!/^\d+(\.\d+)?$/.test(val)) {
        return
      }
      val += ''
      if (val.indexOf('.') > -1) {
        let index = val.indexOf('.')
        val = val.substring(0, index + 3)
      }
      let nowMoney = val
      console.log(nowMoney)
      let realMoney = floatMul(floatDiv(nowMoney, 5), 4) + ''
      if (realMoney.indexOf('.') > -1) {
        let indexR = realMoney.indexOf('.')
        realMoney = realMoney.substring(0, indexR + 3)
      }
      let realGetMoneyNum = parseFloat(realMoney)
      self.realGetMoney = formatCurrency(realGetMoneyNum)
      let lostMoney = floatSub(nowMoney, realGetMoneyNum)
      self.realLostMoney = formatCurrency(lostMoney)
    },
    clickQuestionBtn () {
      this.$weui.dialog({
        title: '提示',
        content: '星客联盟平台将根据《中华人民共和国个人所得税法》代扣代缴应由您本人承担的个人所得税，个税为提现金额的20%；同时，请确保您所提供的实名信息与您所使用的微信实名信息相一致，星客联盟平台将在校验一致后将您所提现的金额（税后）发放至您的微信零钱账户，若因信息不实、不一致导致无法提现，星客联盟平台不承担责任。',
        className: 'custom-classname',
        buttons: [{
          label: '知道了',
          type: 'primary',
          onClick: function () {
            console.log('ok')
          }
        }]
      })
    },
    navigateToWithdraw () {
      let self = this
      if (!self.accountData.hasMobile) {
        self.$weui.dialog({
          title: '提示',
          content: '星客联盟需要验证您的手机号',
          className: 'custom-classname',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function () {
              console.log('cancel')
            }
          }, {
            label: '确定',
            type: 'primary',
            onClick: function () {
              console.log('ok')
              let locationHref = window.location.href
              self.$router.push({path: '/login', query: {fromurl: locationHref}})
            }
          }]
        })
        return
      }
      if (!self.accountData.realSign) {
        self.$weui.dialog({
          title: '提示',
          content: '通过实名认证后才可进行提现操作',
          className: 'custom-classname',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function () {
              console.log('cancel')
            }
          }, {
            label: '实名认证',
            type: 'primary',
            onClick: function () {
              console.log('ok')
              if (this.deviceType !== 0) {
                appCertificationClick()
                return
              }
              self.$router.push('/certification')
            }
          }]
        })
        return
      }
      this.startToWithdraw()
    },
    /**
     * /h5/star/alliance2/star/guest/account/total/obtain/my/account
     * 总的个人账户信息
     */
    getMyAccount () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/total/obtain/my/account'
        })
        .then(res => {
          if (res.success) {
            res.data.availableWithdrawAmountView = formatCurrency(res.data.availableWithdrawAmount)
            if (res.data.availableWithdrawAmount >= 0.38 && res.data.availableWithdrawAmount < 500) self.cashMoney = formatCurrency(res.data.availableWithdrawAmount)
            else if (res.data.availableWithdrawAmount >= 500) self.cashMoney = 500
            else self.cashMoney = 0

            if (self.deviceType === 0) {
              self.isShowBtn = true
            } else {
              self.isShowBtn = res.data.hasOpenId
            }
            self.accountData = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * /h5/star/alliance2/star/guest/withdraw/amount
     */
    nowStartWithdraw () {
      let self = this
      self.cashMoney += ''
      if (self.cashMoney.indexOf('.') > -1) {
        let index = self.cashMoney.indexOf('.')
        self.cashMoney = self.cashMoney.substring(0, index + 3)
      }
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/withdraw/amount',
          params: {
            starGuestNo: self.accountData.starGuestNo,
            withdrawAmount: self.cashMoney
          }
        })
        .then(res => {
          self.canClickBtn = true
          if (res.success) {
            self.$router.push('/withdrawSuccess')
          }
        })
        .catch(err => {
          console.log(err)
          self.canClickBtn = true
        })
    },
    wxShare () {
      let self = this
      self.$fly
        .request({
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: location.href.split('#')[0]
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: false,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: [
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem'
              ]
            })
            self.$wx.ready(function () {
              // 隐藏分享
              self.$wx.hideAllNonBaseMenuItem()
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  activated () {
    let self = this
    self.isShowBtn = false
    this.deviceType = parseInt(localStorage.getItem('USER_DEVICE_TYPE'))
    this.getMyAccount()
    if (this.deviceType === 0) { this.wxShare() }
  },
  mounted () { }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#withdraw {
  width: 100%;
  height: 100vh;
  background: #fff;
}
.cash {
  margin-left: 20px;
  width: calc(100% - 40px);
  border-bottom: 1px solid #eeeeee; /* no */
  .first {
    padding-top: 67px;
    font-size: 28px;
    line-height: 28px;
    color: #000000;
    overflow: hidden;
    .left {
      display: block;
      float: left;
    }
    .right {
      display: block;
      float: right;
      color: #999999;
    }
  }
  .money {
    padding: 100px 0 40px;
    height: 60px;
    div {
      display: block;
      float: left;
      margin-top: 20px;
      font-size: 36px;
      color: #333333;
    }
    input {
      display: block;
      float: left;
      margin-left: 10px;
      width: 80%;
      font-size: 72px;
      border: 0;
    }
  }
}
.msg {
  display: flex;
  margin: 30px 20px 0;
  width: calc(100% - 40px);
  background-color: #fffdf4;
  border-radius: 10px;
  border: solid 1px #ffda8c;
  line-height: 40px;
  font-size: 22px;
  color: #333333;
  padding: 20px;
  span {
    color: #fe7e00;
  }
  label{
    min-width: 66px;
    white-space: nowrap;
  }
  p{
    flex: 1;
  }
}
.btn {
  margin: 112px 20px 0;
  width: calc(100% - 40px);
  height: 88px;
  line-height: 88px;
  background-color: #fb4e2d;
  border-radius: 10px;
  font-size: 36px;
  color: #ffffff;
  text-align: center;
}
.btn_disable {
  background-color: #e9e9e9;
}
/* 提示框 */

.tip {
  margin-top: 50px;
  margin-left: 10px;
  width: calc(100% - 20px);
  height: 80px;
  border-radius: 8px;
  background-color: #f2f2f2;
  position: relative;
  img {
    position: absolute;
    right: 20px;
    width: 40px;
    height: 40px;
    top: 20px;
  }
}
.tip_msg {
  position: absolute;
  line-height: 80px;
  left: 20px;
  font-size: 24px;
  top: 0;
  height: 80px;
}
/* 提示框小角的小方块 */

.tip .inner {
  background-color: #f2f2f2;
  width: 30px;
  height: 30px;
  /* 旋转小方块并调整位置形成尖角 */
  position: relative;
  left: 145px;
  top: -14px;
  transform: rotate(45deg);
  border-right: 0px;
  border-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/mine/withdraw/edit.vue